<template>

  <horganice-purchase-product
    :product="product"
    v-if="product && (product.get('unitType') || product.get('amount') >= 0)"
  />

  <div class="container cid-detail" style="" v-else-if="product">
    <menu-bar />
    <br>
    <br>
    <br>

    <div class="container-img" v-if="product.get('productCode') == 'CID' || product.get('productCode') == 'FRT' || product.get('productCode') == 'BEAM'">
      <img :src="imageUrl" alt="Baner" />
    </div>

    <div class="main">
      <div class="row">
        <div class="col-12" v-if="apartment">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link
                  to="/"
                >หน้าหลัก</router-link>
              </li>
              <li class="breadcrumb-item active" aria-current="page">รายละเอียดสินค้า</li>
            </ol>
          </nav>
        </div>
        <div class="col-md-6">
          <images-carousel v-if="product.get('images').length > 0" :Images="product.get('images')" />
        </div>
        <div class="col-md-6 detail">
          <h3 class="productName">{{product.get('name')}}</h3>
          <!-- <h3 class="productName" >{{product.attributes.name}}</h3> -->
          <!-- <div class="star">
              <i class="fas fa-star starActive"></i>
              <i class="fas fa-star starActive"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
          </div>-->
          <p class="viewerCount">จำนวนการดู {{product.get('viewerCounter') || 0}} ครั้ง</p>
          <p
            v-if="product.get('price')"
          >ราคา {{product.get('price')}} .บาท / {{product.get('unitType')}}</p>
          <!-- <quotation-meter :product="product"/> -->
          <div class="detail" v-if="product.get('detail')">
            <h4>คุณสมบัติสินค้า</h4>
            <div class="ql-snow">
              <div class="ql-editor">
                <div v-html="product.get('detail')"></div>
              </div>
            </div>
          </div>
          <template v-if="product.get('isQuotation')">
            <div class="box-quotaion">
              <div v-if="!isInterested">
                <h6>ขอข้อมูลเพิ่มเติม / ขอใบเสนอราคา</h6>
                <div class="row" style="margin-top: 20px;">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label>ชื่อ - นามสกุล <span>*</span></label>
                      <input
                        v-model="formQuotation.name"
                        type="text" 
                        class="form-control"
                        :disabled="isSaving"
                      >
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>จังหวัด <span>*</span></label>
                      <select
                        v-model="formQuotation.province"
                        type="text" 
                        class="form-control" 
                        @change="changeProvince"
                        :disabled="isSaving"
                      >
                        <option v-for="province in provinces" :value="province.province_name" :key="province.province_id">{{ province.province_name }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>อําเภอ/เขต <span>*</span></label>
                      <select
                        v-model="formQuotation.district"
                        type="text" 
                        class="form-control"
                        :disabled="isSaving"
                      >
                        <option value="popular" disabled>กรุณาเลือกจังหวัด</option>
                        <option v-for="district in districts" :value="district.amphur_name" :key="district.amphur_id">{{ district.amphur_name }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>เบอร์โทรศัพท์ <span>*</span></label>
                      <input
                        v-model="formQuotation.tel"
                        type="text" 
                        class="form-control"
                        :disabled="isSaving"
                      >
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Email</label>
                      <input
                        v-model="formQuotation.email"
                        type="text" 
                        class="form-control"
                        :disabled="isSaving"
                      >
                    </div>
                  </div>
                  <div class="col-md-12 text-danger text-center">
                    <div style="padding-bottom: 10px;">
                      <small v-if="errorFormValidate">{{ errorFormValidate }}</small> 
                    </div>
                  </div>
                  <div class="col-md-12 text-center">
                    <button class="btn-main" style="width: 100px;" @click="requestQuotation()" :disabled="isSaving">ยืนยัน</button>
                  </div>
                </div>
              </div>
              <div v-else>
                <div class="text-center" v-if="!isInterestError">
                  <i class="fas fa-check text-success" style="font-size: 30px;"></i><br>
                  <h5 class="mt-3">เรียบร้อย</h5>
                  <small>ทางทีมงานจะรีบติดต่อกลับไป</small>
                </div>
                <div class="text-center" v-else>
                  <i class="fas fa-times text-danger" style="font-size: 30px;"></i><br>
                  <h5 class="mt-3">เกิดข้อผิดพลาด</h5>
                </div>
              </div>
            </div>
          </template>
          <div style="width:100%" class="text-center" v-if="product.get('quotationLink')">
            <a :href="product.get('quotationLink')" target="_blank">
              <button
                type="button"
                class="btn-main w100-mobile"
                style="margin:25px auto"
              >ขอข้อมูลเพิ่มเติม / ขอใบเสนอราคา</button>
            </a>
          </div>
        </div>
      </div>
      <!-- <div class="col-12 borderBottom"></div> -->
      <div class="discription" v-if="product.get('description')">

        <div class="col-12" style="border-bottom: 1px solid rgba(148, 148, 148, 0.5);">
          <h3><b>ข้อมูลสินค้า</b></h3>
        </div>
        <div class="col-12">
          <div class="tab-content" id="nav-tabContent">
            <div class="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
              <div class="ql-snow">
                <div class="ql-editor">
                  <div v-html="product.get('description')"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <product-carousel :currentProduct="product.id"></product-carousel>
    </div>

    <!-- moadal -->
    <!-- <div class="modal fade bd-example-modal-xl" id="requestQuotationModal" tabindex="-1" role="dialog"
      aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">ขอข้อมูลเพิ่มเติม / ขอใบเสนอราคา</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="ifBox">
            <iframe class="ifQuotation" :src="product.get('quotationLink')"></iframe>
          </div>
        </div>
      </div>
    </div> -->

  </div>
</template>
<script>
import  store  from "../store"
import { mapState } from 'vuex'
import axios from "axios"
export default {
  data() {
    return {
      product: "",
      mainImageUrl: "",
      isInterested: false,
      isInterestError: false,
      errorFormValidate: "",
      isSaving: false,
      formQuotation: {
        productId: this.$route.params.productId,
        name: "",
        tel: "",
        email: "",
        province: "",
        district: "",
      },
      isLoadingDistrict: false,
      provinces: [],
      districts: [],
    };
  },
  async created() {
    this.product = await this.getProduct()
    let { data } = await axios.get("https://app.horganice.in.th/php/thailand.php?data=province")
    this.provinces = data
    if(this.user){
      let profile = this.user.get("userProfile")
      if(profile.get("firstName")) this.formQuotation.name += profile.get("firstName") + " "
      if(profile.get("lastName")) this.formQuotation.name += profile.get("lastName") + " "
      
      if(this.user.get("tel")) this.formQuotation.tel = this.user.get("tel")
      if(this.user.get("email")) this.formQuotation.email = this.user.get("email")
      console.log(this.user)
    }

    this.$gtag.event("view_product", {
      product_id: this.product.id,
      product_name: this.product.get("name"),
      product_category: this.product.get("categories")[0],
    });

    // ------------------------mixpanel---------------------------
    if(this.user) this.$mixpanel.track(`click-product`, {productId: this.product.id , id : this.user.id , tel : this.user.get('tel') , name : this.user.get('userProfile').get('firstName')})
    else this.$mixpanel.track(`click-product`, {productId: this.product.id})
    // -----------------------------------------------------------

    this.Parse.Cloud.run("MarketProduct_counterViewer", {productId: this.$route.params.productId}).catch(err => {console.log(err)})
  },
  methods: {
    changeMainImage(imageUrl) {
      this.mainImageUrl = imageUrl;
    },
    async requestQuotation() {
      this.errorFormValidate = ""
      if(!this.formQuotation.name || !this.formQuotation.tel ||!this.formQuotation.province || !this.formQuotation.district){
        this.errorFormValidate = "กรุณากรอกข้อมูลให้ครบ"
      }else if(!(/^\d{10}$/).test(this.formQuotation.tel)){
        this.errorFormValidate = "กรุณากรอกเบอร์โทรศัพท์ให้ถูกต้อง"
      }else{
        this.isSaving = true
        try{
          console.log(this.formQuotation)
          let quotation = await this.Parse.Cloud.run("MarketQuotation_createQuotation", {
            ...this.formQuotation,
            province: this.formQuotation.province.replaceAll("   ",""),
            district: this.formQuotation.district.replaceAll("   ",""),
          })
          this.$gtag.purchase({
            purchase_id: "Q_" + quotation.id,
            items: [{
              productId: this.product.id,
              productName: this.product.get("name")
            }],
            value: 0
          })
          this.isSaving = false
          this.isInterested = true
        }catch(err){
          this.isSaving = false
          this.isInterested = true
          this.isInterestError = true
        }
      }
      // ------------------------mixpanel---------------------------
      if(this.user) this.$mixpanel.track(`click-request-quotation`, {product: this.product.id , id : this.user.id , tel : this.user.get('tel') , name : this.user.get('userProfile').get('firstName') , apartmentId: this.$route.query.apartmentId})
      else this.$mixpanel.track(`click-request-quotation` , {product: this.product.id})
      // -----------------------------------------------------------
    },
    async getProduct() {
      let product = await this.Parse.Cloud.run("MarketProduct_getProductById", {
        productId: this.$route.params.productId
      }).catch(e => {window.location.href = window.location.origin})
      if (product && !product.get("isRemoved")) {
        return product;
      } else { 
        window.location.href = window.location.origin
      }
    },
    async changeProvince(e) {
      this.isLoadingDistrict = true
      this.formQuotation.district = ""
      let province = this.provinces.find(d => d.province_name == e.target.value)
      let { data } = await axios.get("https://app.horganice.in.th/php/thailand.php?data=amphur&province_id=" + province.province_id)
      this.districts = data
      this.isLoadingDistrict = false
    }
  },
  computed:{
    ...mapState([
      'user',
      'apartment'
    ]),
    imageUrl() {
      if (this.product.get("productCode") == "CID") {
        if (this.product.id == "rWco618dfj") {
          return require("../assets/images/banner/card-reader-gen2.jpg");
        } else {
          return require("../assets/images/banner/card-reader-bn2.jpg");
        }
      } else if (this.product.get("productCode") == "FRT") {
        return require("../assets/images/banner/frt.png");
      } else if (this.product.get("productCode") == "BEAM") {
        return require("../assets/images/banner/beam.jpg");
      } else {
        return ""
      }
    },
  }
};
</script>
<style scoped lang="scss">
$color-text-black-light: rgba(71, 71, 71, 0.671);
.container {
  background-color: #ffffff;
  padding: 5px 20px 40px 20px;
  padding-bottom: 40px;
  max-width: 1300px;

}
.breadcrumb {
  margin-bottom: 0;
  height: 50px;
  background-color: #eaeaea;
}
.breadcrumb li.active {
  color: rgb(124, 124, 124);
}
.breadcrumb li a {
  color: #e9773b;
}
.breadcrumb li:not(.active):hover {
  cursor: pointer;
  text-decoration: underline;
}
.productName {
  color: #e9773b;
  font-weight: bold;
}
img {
  width: 100%;
  height: auto;
}
.mainImage {
  padding: 30px;
}
.subImage {
  margin-top: 10px;
  margin-bottom: 20px;
}
.imageItem {
  margin-top: 10px;
  padding: 1%;
  cursor: pointer;
}
.star i {
  color: #eaeaea;
}
.star .starActive {
  color: #e9773b;
}
.viewerCount {
  margin-bottom: 20px;
  font-size: 12px;
  color: #858585;
}
.btn-quotation {
  text-align: center;
  margin-top: 30px;
}
.detail {
  margin-top: 30px;
}
.discription {
  margin-top: 20px;
  color: rgb(80, 80, 80);
}
/* .nav-tabs .nav-link {
  color: rgb(104, 104, 104);
} */
.nav-tabs .active {
  color: #e9773b;
}
.tab-content {
  padding: 20px 10px 20px 30px;
  min-height: 200px;
}
.ifBox {
  height: 500px;
}
.ifQuotation {
  width: 100%;
  border: none;
  height: 100%;
}
.box-quotaion{
  background-color: #f7f7f7;
  border: 2px solid #e2e2e2;
  border-radius: 10px;
  padding: 15px 20px;
  // max-width: 550px;
  h6{
    font-weight: bold;
    font-size: 20px;
  }
}
label {
  font-size: 14px;
  // font-weight: bold;
  margin: 0px 5px;
  color: rgb(71, 71, 71);

  span {
    font-size: 14px;
    color: red;
  }
}
@media only screen and (max-width: 768px) {
  .borderBottom {
    width: 40%;
    margin: 0 auto;
    margin-top: 50px;
    border: 1px solid black;
  }
  .discription {
    padding: 10px;
  }
  .tab-content {
    padding: 5px 0px 5px 10px;
  }
  .w100-mobile{
    width: 100% !important;
  }
}
@media only screen and (max-width: 540px) {
  .discription {
    padding: 0px;
  }
}
</style>

